import React from 'react';
import { useMemo } from "react";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

const PreviewContainer = styled(Paper)(({ theme }) => ({
  height: '100%',
  padding: '24px',
  overflowY: 'auto',
  borderRadius: 0,
  fontFamily: 'monospace',
  boxShadow: 'none',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  whiteSpace: 'pre-wrap', // Ensures spaces and new lines are preserved
  lineHeight: '0.8', // Improves readability
  '& ul, & ol': {
    paddingLeft: '1.5em' // Ensures nested lists are properly indented
  },
  '& li': {
    marginBottom: '4px' // Adds spacing between list items
  },
  backgroundColor:
    theme.palette.mode === "dark"
      ? "#1a202c"
      : "#f8fafc",
}));

const Preview = React.forwardRef(({ value }, ref) => {
  return (
    <PreviewContainer ref={ref} elevation={3}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml={false} breaks={true}>
        {value}
      </ReactMarkdown>
    </PreviewContainer>
  );
});

export default Preview;
